import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  getAuthToken,
  getPermissionsFromToken,
  userHasPermission,
} from "../utils/auth";

const ProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const location = useLocation();
  const token = getAuthToken();

  if (!token) {
    return <Navigate to="/" replace />;
  }

  const permissions = getPermissionsFromToken();
  const canAccess = userHasPermission(permissions, requiredPermissions);

  if (!canAccess) {
    return (
      <Navigate
        to="/dashboard/unauthorized"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;

